export default {
  newDesign: true,
  parameters: {
    landing_id: "SpQFC",
    segment: 54,
  },
  title: "Cursos de programación para niños de 8 a 17 años | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    footer: true,
    title:
      "Responde a 4 preguntas y obtén un curso gratuito de programación",
    subtitle:
      "Recibirás 3 lecciones interactivas y una sesión individual en línea con un tutor profesional",
    image: {
      url: "/welcome/spain_freecourse_v2_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/spain_freecourse_v2_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Consigue el curso 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "¿Te gustaría que el tiempo que tu hijo/a pasa en la computadora fuera más productivo?",
      answers: ["🔥 ¡Si!", "🤗 No. Lo hace solo para divertirse y eso está bien"],
    },
    2: {
      question: "¿Cuáles son las habilidades de tu hijo/a con la computadora/portátil?",
      answers: [
        "👍 No tiene conocimientos, debe estudiar lo básico",
        "🙌 Nivel básico, sabe usar Power Point y otras aplicaciones",
        "🖥 Nivel intermedio, quiere profundizar conocimientos",
        "🕹 Usa los dispositivos más que nada para juegos",
      ],
    },
    3: {
      question:
        "En estos momentos, ¿Que es lo más importante para ti en el desarrollo de tu hijo/a?",
      answers: [
        "🤔 Habilidades blandas",
        "🎓 Preparación para una carrera a futuro",
        "🖥 Actividades extracurriculares",
      ],
    },
    4: {
      question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true
        },
      ],
    },
    5: {
      title: "¿Cuántos años tiene tu hijo?",
      type: "age",
      button: "",
    },
    6: {
      title: "🎉 Regístrate para una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle: "¡Vamos a conocernos y mostrarte cómo funciona Kodland!<br>En la primera clase, tu hijo creará su propio minijuego y verá cómo son las actividades.<br>¡Y tú puedes acompañarlo!<br><br>👇 Completa tus datos para reservar.",
      button: " ¡Continuar! 🚀 ",
    },
    7: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    8: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    9: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    10: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo tienes que hacer clic en el enlace, te llevará directamente a la clase. Sin aplicaciones adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
